import { common } from '@tencent/ceiba-base-components';
import {
  XIN_YUE_CHANNEL,
  STATUS_ON_WAITING,
  STATUS_ON_DOWNLOADING,
  SPARK_CHANNEL,
  TGCLUB,
  BB_CHANNEL,
} from './constant';
import Vue from 'vue';

function HandleXinYueAppClientDownload() {
  this.gameInfo = {};
  this.remarkKey = '';
  this.defaultAst  = TGCLUB;
  this.getChannel = (gameChannelConfig, astName) => {
    console.log('getChannel gameChannelConfig=', gameChannelConfig);
    if (!gameChannelConfig || gameChannelConfig.length === 0) {
      return XIN_YUE_CHANNEL;
    }
    const that = this;
    const currentAst = astName || that.defaultAst;
    const record = gameChannelConfig.find(item  => item.ast === currentAst);
    console.log('record=', record);
    return  record?.channelNo ?  record?.channelNo : XIN_YUE_CHANNEL;
  };
  this.setGameInfo = async (GameInfos) => {
    const {
      game_name: gameName, version,
      gid: gameId, android_pkg_name: androidPkgName, ios_pkg_name: iosPkgName, ios_download_url: iosDownloadUrl,
      android_download_url: androidDownloadUrl, ios_url_scheme: iosUrlScheme, icon, qq_appid: gameQQAppid, apk_md5: md5,
      activityId, channel_no: channelNo,
    } = GameInfos || {};
    const params = {
      packageName: androidPkgName,
      version,
      gameName,
      icon,
      url: androidDownloadUrl,
      channelId: channelNo,
      from: window?.location?.href || '1015',
      md5,
      gameAppID: gameQQAppid,
      isSilent: false,
      iosPkgName: iosPkgName || androidPkgName,
      iosUrl: iosDownloadUrl,
      iosSchemeUrl: iosUrlScheme,
      activityId,
      gid: gameId,
    };
    this.gameInfo = params;
    console.log('-----HandleXinYueAppClientDownload this.gameInfo =----', this.gameInfo);
    return params;
  };
  this.getRemarkKey = gid => `_gameDownLoadStatus_${gid}_process`;
  // 获取已经安装游戏的渠道id
  // this.getChannelID = () => window.UPBridge?.getAppInstalledChannel(this.gameInfo.packageName, 'channelId');
  this.getChannelID = async () => {
    const response = await window.UPBridge?.getAppInstalledChannel({
      pkgName: this.gameInfo.packageName, // 指定App的包名
      channelTag: 'channelId', // 渠道字段名，默认传 'channelId'
    });
    const { data } = response;
    return parseInt(data.channelInfo, 10);
  };
  // this.doDownloadInIOS = () => window.Tgclub?.downloadApp(JSON.stringify(this.gameInfo));
  this.doDownloadInIOS = () => window.UPBridge?.downloadApp(this.gameInfo);
  this.startDownload = async (callBack) => {
    if (!window.UPBridge && !Vue.prototype.$ast.isAPP()) return;
    if (!this.remarkKey) {
      const that = this;
      this.remarkKey = this.getRemarkKey(this.gameInfo.gid);
      Object.defineProperty(window, this.remarkKey, {
        set: (newValue) => {
          if (typeof callBack === 'function') {
            const { url = '' } = newValue;
            // 多个接收下载 防止污染 客户端的bug
            if (url === that.gameInfo.url) {
              callBack(newValue);
            }
            // 外边进度条
          }
        },
        enumerable: true,
        configurable: true,
      });
    }
    const callbackFunc = `function(ret){if(JSON.parse(ret).totalLen > 0){window.${this.remarkKey} = JSON.parse(ret);}}`;
    console.log('window.UPBridge?.downloadApp this.gameInfo = ', this.gameInfo);
    // window.Tgclub?.downloadApp(JSON.stringify(this.gameInfo), callbackFunc);
    const eventId = await window.UPBridge?.downloadApp(this.gameInfo);
    document.addEventListener(eventId, (e) => {
      const { data } = e.detail;
      if (data.totalLen > 0) {
        window[this.remarkKey] = data;
      }
    });
  };
  this.checkDownloadState = async (callback) => {
    if (!window.UPBridge && !Vue.prototype.$ast.isAPP()) return;
    const response = await window.UPBridge?.checkDownloadState({ url: this.gameInfo.url });
    console.log('checkDownloadState dataJson',  response);
    const { data } =  response;
    const { state = 0, url } = data;
    // 下载状态初始化 同步app下载的状态  等待中 或开始中 触发开始下载
    //  Waitting === 1  ||  Downloading === 2
    if (state === STATUS_ON_WAITING || state === STATUS_ON_DOWNLOADING) {
      this.startDownload(callback);
    }
    if (url === this.gameInfo.url && typeof callback === 'function') {
      callback(data);
    }
  };
  this.stopDownloadApp = () => window.UPBridge?.stopDownloadApp({ url: this.gameInfo.url });
  this.isAppInstalled = async () => {
    const response = await window.UPBridge?.isAppInstalled({ pkgName: this.gameInfo.packageName });
    const { data } = response;
    const getChannelID = await this.getChannelID();
    return data?.isInstall && (getChannelID === parseInt(XIN_YUE_CHANNEL, 10)
      || getChannelID === parseInt(SPARK_CHANNEL, 10)
      || getChannelID === parseInt(BB_CHANNEL, 10));
  };
  this.installGame = () => window.UPBridge?.installDownloadApp({ url: this.gameInfo.url });
  this.callGame = () => window.UPBridge?.openExternalAppByPkgName({ pkgName: this.gameInfo.packageName });
  //  是否显示下载 app
  this.isShowDownloadComponent = () => !(window.navigator.userAgent.toLowerCase().indexOf('islegalversion') > -1);
  this.beforeDownloadCheck = () => {
    if (!window.UPBridge && !Vue.prototype.$ast.isAPP()) {
      return '';
    }
    const currentVersion = this.getAppVersion();
    console.log('currentVersion =', currentVersion);
    if (!currentVersion) {
      return '';
    }
    if (window.navigator.userAgent.toLowerCase().indexOf('islegalversion') > -1
      && ['6.0.1.51', '6.0.1.52', '6.0.1.53'].some(v => v === currentVersion)) {
      return '当前版本暂不支持下载，请升级到最新版本后继续下载';
    }
    return '';
  };
  // 心悦app上报 染色SDK曝光上报
  this.reportGameChanelDownloadViewShow = () => {
    console.log('access reportGameChanelDownloadViewShow', this.gameInfo);
    if (!window.UPBridge && !Vue.prototype.$ast.isAPP()) {
      return false;
    }
    if (window.UPBridge && typeof window.UPBridge?.downloadComponentExpose !== 'function') {
      return false;
    }
    // const jsonStr = JSON.stringify(this.gameInfo);
    window.UPBridge?.downloadComponentExpose(this.gameInfo);
  };
  // 获取app版本
  this.getAppVersion = function () {
    const str = navigator.userAgent.toLowerCase();
    if (!str) {
      return '';
    }
    if (str.match('tgclub') === null) {
      return '';
    }
    const reg = new RegExp('tgclub/([0-9.]+)');
    const res = str.match(reg);
    if (!res?.[1]) {
      return '';
    }
    if (!res[1] instanceof Array || res[1].length === 0) {
      return '';
    }
    return res[1];
  };
  // 是否uo上报 暂停下载
  this.needReportDownloadPause = true;
  // 是否uo上报 完成下载
  this.needReportDownloadFinish = true;
  // 是否uo上报 安装游戏
  this.needReportInstallGame = true;
  // 是否uo上报  拉起游戏
  this.needReportlaunchGame = true;
  /**
   * 检测app  是否大于某个版本 版本参数
   * @param versions    [6, 2, 0, 1]
   * @returns {boolean}
   */
  this.isAppVersionBiggerThan = (versions) => {
    const currentVersion = this.getAppVersion();
    if  (!currentVersion) {
      return  false;
    }
    const [v1 = 0, v2 = 0, v3 = 0, v4 = 0] = currentVersion.split('.').map(num => parseInt(num, 10));
    console.log('v1 v2 v3 v4', v1, v2, v3, v4);
    const [c1 = 0, c2 = 0, c3 = 0, c4 = 0] = versions;
    console.log('c1 c2 c3 c4', c1, c2, c3, c4);
    if (v1 - c1 < 0) {
      return false;
    }
    if (v1 - c1 > 0) {
      return true;
    }
    if (v2 - c2 < 0) {
      return false;
    }
    if (v2 - c2 > 0) {
      return true;
    }
    if (v3 - c3 < 0) {
      return false;
    }
    if (v3 - c3 > 0) {
      return true;
    }
    if (v4 - c4 < 0) {
      return false;
    }
    if (v4 - c4 > 0) {
      return true;
    }
    if (v1 === c1 && v2 === c2 && v3 === c3 && v4 === c4) {
      return false;
    }
    return false;
  };
  this.startPreDownload = packageName =>  window.UPBridge?.startPreDownload({ pkgName: packageName });
  /**
   * @param packageName
   * @returns {Promise<*>}
   * { ret: 0, totalCount: 1, downLoadCount: 1, recevivedLen: 50, totalLen: 100 };
   * ret; 状态码：0正常，可读取进度;1，未启动，先调用启动下载接口；-1，当前游戏无需预下载
   * recevivedLen;    已下载长度，单位是bytes
   * totalLen：总长度
   * path;           文件存储路径
   * totalCount;     预下载资源包总数
   * downLoadCount;  已下载的资源包个数
   */
  this.getPreDownloadProcess = async (packageName) =>  {
    const res = await window.UPBridge?.getPreDownloadProcess({ pkgName: packageName });
    console.log(' query xinyue app getPreDownloadProcess  =', res.data);
    return res.data;
  };
  // 心悦预下载前置判断
  this.beforePreDownloadCheck = () => {
    if  (!this.isAppVersionBiggerThan([6, 2, 0, 1])) {
      return  '请更新心悦俱乐部APP至6.2.0.1版本后进行预下载~';
    }
    return  '';
  };
  console.log('-----------------------------init done HandleXinYueAppClientDownload');
  return this;
}

export default HandleXinYueAppClientDownload;
export { HandleXinYueAppClientDownload };
